import { render, staticRenderFns } from "./intelligentbroadcastSystem.vue?vue&type=template&id=5504d000&scoped=true"
import script from "./intelligentbroadcastSystem.vue?vue&type=script&lang=js"
export * from "./intelligentbroadcastSystem.vue?vue&type=script&lang=js"
import style0 from "./intelligentbroadcastSystem.vue?vue&type=style&index=0&id=5504d000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5504d000",
  null
  
)

export default component.exports